import React, {useState} from 'react';
import WhatsOnIcon from '../../icons/WhatsOnIcon';
import Button from '@mui/material/Button';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import IconButton from '@mui/material/IconButton';
import {ValidatorForm, TextValidator} from 'react-material-ui-form-validator';
import {api} from '../../maps/data.js';
import {setLogin} from '../../domain/loginSlice';
import {Navigate, useLocation, useNavigate} from "react-router-dom";
import useZibi from "../../zibi/UseZibi";
import {permissionsMap} from "../../maps/permissionsMap";


function AdminLoginPage() {
    const navigate = useNavigate();
    const location = useLocation();
    const [email, setEmail] = useState();
    const [password, setPassword] = useState();
    const [showPassword, setShowPassword] = useState(false);
    const [isLoggedIn] = useZibi('isLoggedIn');
    const [initialRoutePath] = useZibi('initialRoutePath');

    const login = async () => {
        const tokens = await api({
            type: 'login',
            data: {
                email,
                password
            }
        });

        setLogin(tokens, (defaultRoute) => {
            navigate(defaultRoute);
        });
    };

    if (isLoggedIn) {
        let routeToUse = initialRoutePath;
        if (!routeToUse) {
            const userRole = zibi.user.role[0];
            routeToUse = permissionsMap[userRole].defaultRoute;
        }
        return <Navigate to={routeToUse} state={{from: location}} replace/>;
    }

    return (
        <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center',
            minHeight: '100vh'
        }}>
            <div>
                <WhatsOnIcon size="80"/>
                <ValidatorForm
                    onSubmit={login}
                    onError={errors => console.log(errors)}>

                    <TextValidator
                        value={email}
                        onChange={e => setEmail(e.target.value)}
                        style={{display: 'block', marginTop: 10}}
                        id="login-email"
                        label="Email"
                        variant="outlined"
                        validators={['required', 'isEmail']}
                        errorMessages={['this field is required', 'email is not valid']}
                    />

                    <div style={{position: 'relative'}}>

                        <TextValidator
                            type={showPassword ? 'text' : 'password'}
                            value={password}
                            onChange={e => setPassword(e.target.value)}
                            style={{display: 'block', marginTop: 10}}
                            id="login-password"
                            label="Password"
                            variant="outlined"
                            validators={['required']}
                            errorMessages={['this field is required']}
                        />

                        <IconButton style={{position: 'absolute', right: 10, top: 9}}
                                    onClick={() => setShowPassword(!showPassword)}>
                            {
                                showPassword ? <VisibilityOffIcon/> : <VisibilityIcon/>
                            }
                        </IconButton>

                    </div>
                    <Button type="submit" style={{width: 195, marginTop: 10}} variant="contained">Login</Button>
                </ValidatorForm>

            </div>
        </div>);
}

export default AdminLoginPage;